// Import the functions you need from the SDKs you need
import { useMutation } from "@tanstack/react-query";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { fetchApi } from "../api/api";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCWcYM8mQMryUXx-fxqtvke-JtOpeW34As",
  authDomain: "uhtraining-6b0de.firebaseapp.com",
  projectId: "uhtraining-6b0de",
  storageBucket: "uhtraining-6b0de.firebasestorage.app",
  messagingSenderId: "235610838580",
  appId: "1:235610838580:web:3f69f1d225d29efcd19c61",
  // measurementId: "G-P1PKGDFEDD"
}; // Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const onMessager = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export const Sendrequest = () => {
  console.log("Requesting User Permission……");

  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      console.log("Notification User Permission Granted.");

      return getToken(messaging, {
        vapidKey: `BIkoGj_BR-Fo8PAq3ZNiswPJIWEtN8GRZoHwclJXSp6upyeGNTnOG6Yt7-o33s5TuPrpG6joYBXVhxkJHeiERE8`,
      })
        .then((currentToken) => {
          if (currentToken) {
            fetchApi("/auth/notification/deviceToken", "POST", {
              platform: "web",
              device_token: currentToken,
            }).then((res) => {
              console.log(res);
              if (res.status === 200) {
                console.log("Token saved successfully.");
                console.log(res.data.data.id);
                localStorage.setItem("deviceId", res.data.data.id);
              }
            });
          } else {
            console.log("Failed to generate the registration token.");
          }
        })

        .catch((err) => {
          console.log(
            "An error occurred when requesting to receive the token.",
            err
          );
        });
    } else {
      console.log("User Permission Denied.");
    }
  });
};
